/* global svvSearchList */
export default function (key) {
  if (typeof svvSearchList === 'undefined') {
    return false;
  }

  if (typeof svvSearchList[key] === 'undefined') {
    return false;
  }

  return svvSearchList[key];
}
